"use strict";

exports.__esModule = true;
exports.DashboardDataProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DashboardURLFilter = require("../DashboardURLFilter");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _URLFilter = require("../../Core/URLFilter");
var _ReportingPeriod = require("../../Time/ReportingPeriod");
var _PlantStateActivities = require("../../PlantStateActivities");
var _dec, _class, _DashboardDataProvider;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Provides data to dashboards via contexts.
 */
var DashboardDataProvider = exports.DashboardDataProvider = (_dec = _DeviceListContext.DeviceListContext.withContext, _dec(_class = (_DashboardDataProvider = /*#__PURE__*/function (_Component) {
  function DashboardDataProvider() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(DashboardDataProvider, _Component);
  var _proto = DashboardDataProvider.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      devices = _this$props.devices,
      children = _this$props.children;
    return /*#__PURE__*/_react["default"].createElement(_DashboardURLFilter.DashboardURLFilter, null, function (urlFilter) {
      var _urlFilter$filters = urlFilter.filters,
        tags = _urlFilter$filters.tags,
        deviceTypes = _urlFilter$filters.deviceTypes,
        plantTwinDevices = _urlFilter$filters.devices;
      var filteredDevices = devices;
      if (tags.length > 0) {
        filteredDevices = filteredDevices.filter(function (device) {
          return device.tags.some(function (tag) {
            return tags.includes(tag);
          });
        });
      }
      if (deviceTypes.length > 0) {
        filteredDevices = filteredDevices.filter(function (device) {
          return Array.isArray(deviceTypes) && deviceTypes.length ? deviceTypes.includes(device.deviceType) : true;
        });
      }
      if (plantTwinDevices.length > 0) {
        filteredDevices = filteredDevices.filter(function (device) {
          return Array.isArray(plantTwinDevices) && plantTwinDevices.length ? plantTwinDevices.includes(device.uuid) : true;
        });
      }
      return /*#__PURE__*/_react["default"].createElement(_URLFilter.URLFilterContext.Provider, {
        value: urlFilter
      }, /*#__PURE__*/_react["default"].createElement(_DeviceListContext.DeviceListContext.Provider, {
        value: filteredDevices
      }, /*#__PURE__*/_react["default"].createElement(_PlantStateActivities.PlantStateFilterContext.Provider, null, /*#__PURE__*/_react["default"].createElement(_PlantStateActivities.PlantStateFilterContext.Consumer, null, function (_ref) {
        var stateFilteredDevices = _ref.devices;
        return /*#__PURE__*/_react["default"].createElement(_DeviceListContext.DeviceListContext.Provider, {
          value: stateFilteredDevices
        }, /*#__PURE__*/_react["default"].createElement(_ReportingPeriod.ReportingPeriodController, null, function (reportingPeriod) {
          return /*#__PURE__*/_react["default"].createElement(_ReportingPeriod.ReportingPeriodContext.Provider, {
            value: reportingPeriod
          }, children);
        }));
      }))));
    });
  };
  return DashboardDataProvider;
}(_react.Component), _DashboardDataProvider.defaultProps = {
  devices: undefined
}, _DashboardDataProvider)) || _class);